import { gql } from "@apollo/client";

import { SEARCH_SUGGESTIONS_FRAGMENT } from "constants/suggestions";

export const SEARCH_WEBHOOKS = gql`
  query SearchNamedWebhooksIntegrations($input: SearchInput!) {
    searchNamedWebhooksIntegrations(input: $input) {
      edges {
        cursor
        node {
          id
          createdAt
          plugin {
            id
            name
          }
          space {
            id
            name
            accessLevel
          }
          enabled
          endpoint
          labels
          name
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`;

export const SEARCH_WEBHOOKS_SUGGESTIONS = gql`
  query SearchNamedWebhooksIntegrationsSuggestions($input: SearchSuggestionsInput!) {
    searchNamedWebhooksIntegrationsSuggestions(input: $input) {
      ...SearchSuggestionsFragment
    }
  }
  ${SEARCH_SUGGESTIONS_FRAGMENT}
`;

export const WEBHOOK_DELETE = gql`
  mutation WebhookDelete($id: ID!) {
    namedWebhooksIntegrationDelete(id: $id) {
      id
    }
  }
`;
